import { error } from "console";
import { GET_PERMISSION_LIST_FAILURE, GET_PERMISSION_LIST_REQUEST, GET_PERMISSION_LIST_SUCCESS } from "../constats/permissions.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
};

export const permissionsListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_PERMISSION_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
                data: [],
                error: ''
            };
        }
        case GET_PERMISSION_LIST_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: ''
            };
        }

        case GET_PERMISSION_LIST_FAILURE: {
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        }

        default: {
            return {
                ...state,
                loading: false
            }
        }
    }
}